import { InitialState } from '@common/types';
import { atom, useAtomValue } from 'jotai';

export const initialStateAtom = atom<InitialState>(window.__INITIAL_STATE__ || ({} as InitialState));

export const loggedIn = atom(
  (get) => {
    const initialState = get(initialStateAtom);
    return initialState?.isLoggedIn ?? false;
  },
  (get, set, newValue: boolean) => {
    const currentState = get(initialStateAtom);
    set(initialStateAtom, { ...currentState, isLoggedIn: newValue });
  },
);

export const useLoggedIn = () => {
  return useAtomValue(loggedIn);
};
